var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0527 0.000610352H19.9616C8.94466 0.000610352 0.0136719 8.93424 0.0136719 19.9544V20.0455C0.0136719 31.0657 8.94466 39.9993 19.9616 39.9993H20.0527C31.0696 39.9993 40.0006 31.0657 40.0006 20.0455V19.9544C40.0006 8.93424 31.0696 0.000610352 20.0527 0.000610352Z",
    fill: "url(#paint0_linear_115_1100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58737 19.3184C7.64341 19.2904 7.69947 19.2637 7.75411 19.2385C8.70394 18.7985 9.66639 18.3865 10.6274 17.9745C10.6793 17.9745 10.7661 17.9142 10.8151 17.8946C10.8894 17.8624 10.9636 17.8316 11.0379 17.7993C11.1808 17.7377 11.3237 17.6774 11.4652 17.6157C11.751 17.4938 12.0354 17.3719 12.3211 17.25L14.0317 16.5171C15.172 16.0294 16.3138 15.5403 17.4542 15.0527C18.5946 14.565 19.7363 14.0759 20.8767 13.5883C22.017 13.1006 23.1588 12.6115 24.2992 12.1239C25.4395 11.6362 26.5813 11.1471 27.7217 10.6594C27.9752 10.5501 28.2498 10.3876 28.5216 10.3399C28.75 10.2993 28.9727 10.2208 29.2024 10.1774C29.6381 10.0947 30.1187 10.0611 30.5361 10.2418C30.6804 10.3049 30.8135 10.3932 30.9242 10.5039C31.4537 11.028 31.3795 11.8884 31.2674 12.6255C30.4871 17.7629 29.7068 22.9016 28.9251 28.039C28.8186 28.7439 28.6729 29.5174 28.1167 29.963C27.646 30.34 26.9763 30.382 26.395 30.2223C25.8136 30.0611 25.3008 29.7234 24.7979 29.3913C22.7119 28.0096 20.6245 26.6278 18.5385 25.2461C18.0426 24.9182 17.4906 24.4894 17.4962 23.8938C17.499 23.535 17.7134 23.2155 17.9319 22.9311C19.7447 20.5656 22.3603 18.94 24.3062 16.6838C24.5808 16.3657 24.7965 15.7912 24.4197 15.6076C24.1955 15.4983 23.9377 15.6468 23.7332 15.7884C21.1611 17.5751 18.5904 19.3632 16.0182 21.1499C15.1791 21.7329 14.2993 22.3327 13.2878 22.4756C12.3828 22.6046 11.4722 22.3523 10.5966 22.0945C9.86252 21.8786 9.12981 21.6572 8.39992 21.4288C8.01186 21.3083 7.61119 21.178 7.31139 20.9047C7.01159 20.6314 6.8393 20.1718 7.02002 19.8075C7.13349 19.579 7.35344 19.4347 7.5846 19.317L7.58737 19.3184Z",
    fill: "#FEFFFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_1100",
    x1: 40.0006,
    y1: 39.9993,
    x2: -8.23575,
    y2: 18.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group-3.29e1e7d13b872f47c49c6fa5d9e97e04.svg";
export { ForwardRef as ReactComponent };